<template>
  <div class="d-inline-block">
    <b-popover :show.sync="show"
               @click="show = false"
               :target="btnId">
      <template slot="title">
        <v-btn @click="show = false"
               flat icon class="ma-0">
          <v-icon small>close</v-icon>
        </v-btn>
      </template>
      <slot></slot>
    </b-popover>

    <v-btn flat icon color="accent"
           class="ma-0"
           @click="toggle()"
           :id="btnId">
      <v-icon>live_help</v-icon>
    </v-btn>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'HelpPopover',
  data() {
    return {
      show: false,
      btnId: null,
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
  created() {
    this.btnId = _.uniqueId();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelpPopover.vue